/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Lib dependencies
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

// Services
import { MeetingService } from "@/services/meeting.service";
import { queryClient } from "@/providers/QueryClientProvider";

/* -------------------------------------------------------------------------- */
/*                              Add meeting Hook                              */
/* -------------------------------------------------------------------------- */
const meetingService = new MeetingService();

type UseAddMeetingProps = {
  onSuccess?: () => void;
};

const useAddMeeting = ({ onSuccess }: UseAddMeetingProps) => {
  const { t } = useTranslation();
  const { mutate, isPending } = useMutation({
    mutationFn: meetingService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meetings"] });
      onSuccess?.();
      toast.success(t("pages.meetings.meeting_created_successfully"));
    },
    onError: () => {
      toast.error(t("api_errors.an_error_occured"));
    },
  });

  return { mutate, isPending };
};

export { useAddMeeting };
